import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMonitoringGoods } from './MonitoringContext';
import { LayoutTabSection as LayoutTab } from '../orders/_layouts/LayoutTabSection';
import { LayoutOrderContainer, LayoutTabSection } from '../orders/_layouts/LayoutOrderContainer';
import { ChevronLeft } from 'lucide-react';
import GoodsDetailSticky from './GoodsDetailSticky';
import GoodsDetailKeyword from './GoodsDetailKeyword';
import GoodsDetaiiPriceChart from './GoodsDetaiiPriceChart';
import useCheckMembership from '@/hooks/useCheckMembership';
import { MOCK_GOODS } from './_mock/mockGoods';

const GoodsDetailPanel = () => {
  const [searchParams] = useSearchParams();
  const goodsNo = searchParams.get('select');

  const { goods, isLoading, isError } = useMonitoringGoods();

  // const selectedGoods = goods.find((item) => String(item.GoodsNo) === String(goodsNo));
  const selectedGoods =
    goods.find((item) => String(item.GoodsNo) === String(goodsNo)) ||
    MOCK_GOODS.find((item) => String(item.GoodsNo) === String(goodsNo));

  const navigate = useNavigate();

  // selectedGoods를 못 찾으면 자동으로 select 쿼리 삭제 후 이동
  useEffect(() => {
    if (!isLoading && !isError && !selectedGoods) {
      const params = new URLSearchParams(searchParams);
      params.delete('select');
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [selectedGoods, isLoading, isError, searchParams, navigate]);

  const dailyList = selectedGoods?.MonitoringGoodsDetailDailyList;
  const isCollecting = !dailyList || dailyList.length === 0;
  const isMember = useCheckMembership();

  if (isLoading) return <div>로딩 중...</div>;
  if (isError) return <div>에러 발생</div>;
  if (!selectedGoods) return null; // 위 useEffect에서 처리됨

  return (
    <LayoutOrderContainer className="overflow-y-auto bg-gr-50">
      <LayoutTabSection>
        <BackwardSection />
      </LayoutTabSection>
      <GoodsDetailSticky goods={selectedGoods} />
      <div className="relative flex flex-col gap-[20px] pb-[55px] pt-[10px]">
        <GoodsDetailKeyword />
        <GoodsDetaiiPriceChart />

        {/* 오버레이: 데이터가 없을 때만 표시 */}
        {isCollecting && (
          <div className="absolute inset-0 z-10 flex items-center justify-center rounded-[16px] bg-gr-50/80 backdrop-blur-[1px]">
            <div className="font-semibold text-point-500 Body1S16">데이터를 수집중입니다</div>
          </div>
        )}
      </div>
    </LayoutOrderContainer>
  );
};

export default GoodsDetailPanel;

const BackwardSection = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleBackward = () => {
    const params = new URLSearchParams(searchParams);
    params.delete('select');
    navigate({ search: params.toString() });
  };

  return (
    <LayoutTab>
      <div
        onClick={handleBackward}
        className="flex cursor-pointer items-center gap-3 text-gr-900 Title2S24"
      >
        <ChevronLeft className="h-[32px] w-[32px]" />
        뒤로가기
      </div>
    </LayoutTab>
  );
};
